import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

// project imports
import Loader from 'components/Loader';
import { selectAuthStatus } from './authSlice';

// ==============================|| AUTH GUARD - REQUIRE AUTH ||============================== //

export default function RequireAuth() {
  const status = useSelector(selectAuthStatus);
  const location = useLocation();

  if (status === 'loading') {
    return <Loader />;
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
